<template>
  <div class="app">
    <header v-if="!$route.meta.headerHide && $route.path != '/'">
      <div class="app-sticky">
        <van-nav-bar
          :title="$route.meta.title"
          :left-text="$route.meta.title"
          :left-arrow="$route.meta.leftBtnHide ? false : true"
          @click-left="onClickLeft"
        ></van-nav-bar>
      </div>
    </header>
    <div id="appContent">
      <router-view />
    </div>
    <footer>
      <van-tabbar
        v-show="$route.meta.footerShow"
        v-model="active"
        active-color="#1a347b"
        inactive-color="#c6c6c6"
        safe-area-inset-bottom
      >
        <van-tabbar-item
          v-for="(item, index) in tabbars"
          :key="index"
          :to="item.path"
          @click="onChange(index, item.path, item.name)"
        >
          <span>{{ item.title }}</span>
          <template slot="icon" slot-scope="props">
            <img :src="props.active ? item.active : item.normal" />
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </footer>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Grid,
  GridItem,
  Icon,
  Button,
  Tabbar,
  TabbarItem,
  NavBar,
  NoticeBar,
} from "vant";
import { getRoute, getPlatform } from "@/plugins/environment/type.js";

Vue.use(NavBar).use(NoticeBar);
export default {
  name: "App",
  components: {
    [Button.name]: Button,
    [Grid.name]: Grid,
    [Icon.name]: Icon,
    [GridItem.name]: GridItem,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [NavBar.name]: NavBar,
    [NoticeBar.name]: NoticeBar,
  },
  data() {
    return {
      platform: getPlatform(),
      active: 0,
      route: "app",
      tabbars: [
        {
          path: getRoute() + "home",
          name: "Home",
          title: this.$t.meta.homePage,
          normal: require("@/assets/img/home/home.png"),
          active: require("@/assets/img/home/home_fill.png"),
        },
        {
          path: getRoute() + "user/userManage",
          name: "User",
          title: this.$t.meta.userPage,
          normal: require("@/assets/img/home/my.png"),
          active: require("@/assets/img/home/my_fill.png"),
        },
      ],
    };
  },
  watch: {
    $route(to, from) {
      setTimeout(() => {
        this.setContentClasses(to.meta.stickyHeader);
      });
    },
  },
  methods: {
    setContentClasses(isSticky) {
      const element = document.getElementById("appContent");
      var classes = [];
      if (isSticky) {
        classes.push("middle");
      }
      var isAuth = this.$route.path.includes("auth");
      var isNotApp = this.$route.path == "/" + this.route;
      if (isAuth || isNotApp) {
        classes.push("none-bottom");
      } else {
        classes.push("mb-bottom");
      }
      element.className = classes.join(" ");
    },
    onChange(index) {
      this.active = index;
      if (this.active == index) {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
    onClickLeft() {
      if (this.$route.meta.backUser) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.backUser);
      } else if (this.$route.meta.backHome) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.backHome);
      } else {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
      }
    },
  },
  created() {
    this.active = 0;
    this.route = getRoute(true);
  },
  updated() {
    if (this.$route.path.includes("home")) {
      this.active = 0;
    } else if (this.$route.path.includes("user")) {
      this.active = 1;
    } else {
      this.active = 0;
    }
  },
};
</script>
<style></style>
<style lang="scss" scoped>
.app {
  header {
    height: auto;
  }
  header ::v-deep .app-sticky {
    position: fixed;
    top: 0;
    left: 0;
    padding-top: calc(env(safe-area-inset-top));
    z-index: 999;
    width: 100%;
    background-color: #ffffff;
  }
  header ::v-deep .van-nav-bar {
    background: transparent;
    line-height: 49px;
    border-bottom: 1px solid #e4e9f0;
  }
  header ::v-deep .van-nav-bar__content {
    height: auto;
  }
  header ::v-deep .van-nav-bar__title {
    color: #fff;
    font-size: 1.2rem;
    visibility: hidden;
  }
  header ::v-deep .van-nav-bar__text {
    color: #000 !important;
    font-size: 15px;
    font-weight: bold;
  }
  header ::v-deep .van-nav-bar__arrow {
    color: #666;
    font-size: 1.5rem;
    margin-right: 10px;
  }
  header ::v-deep .van-hairline--bottom::after {
    display: none;
  }
  header img {
    width: 0.66rem;
    height: 0.57rem;
    vertical-align: middle;
  }
  footer {
    height: auto;
    line-height: 1rem;
    color: #fff;
  }

  footer img {
    width: 1.5rem;
    height: 1.5rem;
  }
  footer ::v-deep .van-tabbar {
    height: auto;
    color: #999;
    z-index: 100 !important;
    padding-top: 5px;
    padding-bottom: calc(5px + env(safe-area-inset-bottom));
    border-top: 5px solid #f6f6f6;
  }
  [class*="van-hairline"]::after {
    /* border: 0 solid #0f0f1a; */
  }
  .van-notice-bar {
    position: fixed;
    bottom: calc(50px + env(safe-area-inset-bottom));
    left: 0px;
    width: -webkit-fill-available;
    opacity: 0.9;
    line-height: normal;
  }
  footer ::v-deep .van-notice-bar__left-icon {
    font-size: 25px;
    margin-right: 5px;
    margin-bottom: 2px;
  }
  footer ::v-deep .van-tabbar-item__text {
    font-weight: 500;
  }
  .middle {
    margin-top: calc(50px + env(safe-area-inset-top));
  }
  .none-bottom {
    margin-bottom: 0vw;
  }
  .mb-bottom {
    margin-bottom: 30vw;
  }
}
</style>
